import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { getMostPreferredCategory } from '@/pages/Onboarding/utils/getMostPreferredCategory';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import './DressUp.scss';

export const OnboardingReplikaDressUp: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'DressUp',
      });
    }
  }, []);

  const { watch } = useFormContext<LayoutDataType>();
  const categories = watch('categories');
  const outfit = watch('outfits');

  const preferredCategory = getMostPreferredCategory(categories);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  const getAiImageSrc = () => {
    if (outfit === 'hot' || outfit === 'unique') {
      return `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${preferredCategory.key}/outfit-hot.png`;
    }

    return `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${preferredCategory.key}/outfit-casual.png`;
  };

  return (
    <OnboardingPage className="onboarding-dress-up">
      <IonContent>
        <div className="img-container">
          <img
            src={getAiImageSrc()}
            alt="relationships"
            onError={(e) => {
              e.currentTarget.src = `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${preferredCategory.key}/outfit-casual.png`;
            }}
          />
        </div>
        <OnboardingTitle className="onboarding-dress-up__title">
          Dress Up Characters
        </OnboardingTitle>
        <OnboardingSubtitle>
          Gift outfits to your favorite characters and get a photo of them
          wearing it!
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
